  <template>
    <div class="publication">
      <div class="publication__image-container">
        <div
          v-if="hasImageUrl"
          :class="imageClass"
          >
          <picture class="picture--center">
            <img
              class="picture__img--scale"
              :src="publication.URL"
              >
          </picture>
        </div>
        <div
          v-else
          class="work-placeholder-image"
          />
      </div>
      <div
        class="publication__detail"
        data-publication-details="publication.Id.Int64"
        >
        <div class="publication-info">
          <span
            v-if="publication.DisplayTitle"
            class="publication-info__title__text balance-text"
            v-html="publication.DisplayTitle"
            />
          <span
            v-if="publication.AuthorWithDate"
            class="publication-info__author-date__text balance-text"
            v-html="publication.AuthorWithDate"
            />
          <span
            v-if="publication.BookDetails"
            class="publication-info__details__text"
            v-html="publication.BookDetails"
            />
          <span
            v-if="publication.ISBN.Valid"
            class="publication-info__details__text"
            >
            ISBN {{ publication.ISBN.String }}
          </span>
        </div>
        <supplementaLinks
          :exhibition-id="exhibitionId"
          :pdfs="pdfs"
          :sku="storeSku"
          />
      </div>
    </div>
</template>

<script>
  import supplementaLinks from './supplemental-links.vue';

  export default {
    components :{ supplementaLinks },

    props: {
      publication: { type: Object, required: true },
    },

    computed: {
      hasImageUrl() {
        return this.publication.URL != '';
      },

      imageClass() {
        if (this.publication.UseStoreImageClass) {
          return 'publication__image--legacy-store';
        }
        return 'publication__image';
      },

      exhibitionId() {
        if (this.publication.ExhibitionId !== 'undefined' && this.publication.ExhibitionId.Valid) {
          return this.publication.ExhibitionId.Int64;
        }
        return -1;
      },

      pdfs() {
        if (this.publication.PdfURL.Valid) {
          return [{
          "Url": this.publication.PdfURL.String,
          "TranslationKey":this.translationKey
          }];
        }
        return [];
      },

      translationKey() {
        if (this.publication.PdfIsSample.Valid && this.publication.PdfIsSample.Bool) {
          return "publication__sample-link";
        }

        return "publication__view-link";
      },

      storeSku() {
        var sku = this.publication.Sku.String;
        sku = sku.replace(/ /g, '');
        if (sku.indexOf('-') === -1) {
          sku = `${sku}-${sku}`;
        }
        if (this.publication.ProductStyle.String != '') {
          sku = `${this.publication.ProductStyle.String}-${this.publication.Sku.String}`;
        }
        return sku;
      },
    },
  };
</script>
